
export function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/5535988228452"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 w-16 h-16 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl flex items-center justify-center transition-all hover:scale-110 cursor-pointer group"
      aria-label="Fale conosco pelo WhatsApp"
    >
      <i className="ri-whatsapp-line text-3xl"></i>
      <span className="absolute right-20 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
        Fale conosco pelo WhatsApp
      </span>
    </a>
  );
}
